import { render } from "./employee-policy.vue?vue&type=template&id=61454ccc"
import script from "./employee-policy.vue?vue&type=script&lang=js"
export * from "./employee-policy.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__